import { Loadable } from '../../Loadable';

export const AsyncVenuesContainer = Loadable(() => import('./List'));
export const AsyncVenueHealth = Loadable(() => import('./Health'));
export const AsyncCreateVenue = Loadable(() => import('./Create'));
export const AsyncEditVenue = Loadable(() => import('./Edit'));
export const AsyncEditConfig = Loadable(() => import('./EditConfig'));
export const AsyncBraintreeForm = Loadable(() => import('./BraintreeForm'));
export const AsyncBraintreeStatus = Loadable(() => import('./CheckBraintreeStatus'));
